export default __webpack_public_path__ + "static/media/notfound.3381b0a4.svg";